import { render, staticRenderFns } from "./home-collection-list.vue?vue&type=template&id=7ac6fc52&scoped=true"
import script from "./home-collection-list.vue?vue&type=script&lang=js"
export * from "./home-collection-list.vue?vue&type=script&lang=js"
import style0 from "./home-collection-list.vue?vue&type=style&index=0&id=7ac6fc52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac6fc52",
  null
  
)

export default component.exports